import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import url from "../../function/url";
import axios from "axios";
import { useNavigate, NavLink } from "react-router-dom";
import { FaBars, FaChevronDown, FaChevronUp, FaTimes } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MdCardMembership } from "react-icons/md";
import {
  faUser,
  faUsers,
  faBriefcase,
  faFileAlt,
  faSignOutAlt,
  faFileCirclePlus,
  faList,
  faGears,
  faArchive,
} from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
function EmployeeNavbar() {
  const ID = Cookies.get("log_id");
  const navigate = useNavigate();
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    },
  });
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isprofileDropdown, setProfiledropdown] = useState(false);
  const [isOptiondown, setOptiondropdown] = useState(false);
  const [isProductsdown, setProductsdrop] = useState(false);
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const toggleProfile = () => {
    setProfiledropdown(!isprofileDropdown);
  };
  const toggleOption = () => {
    setOptiondropdown(!isOptiondown);
  };
  const toggleProducts = () => {
    setProductsdrop(!isProductsdown);
  };
  const [username, setUsername] = useState("");
  const [image, setImage] = useState("");
  function LoginDetails() {
    axios
      .get(`${url.path}/login_details/${ID}/`)
      .then((res) => {
        if (res.data.status) {
          setUsername(res.data.name);
          const img = res.data.image;
          var imag = null;
          if (img) {
            imag = `${url.path}/${img}`;
          }
          setImage(imag);
        }
      })
      .catch((err) => {
        Toast.fire({
          icon: "error",
          title: err,
        });
      });
  }
  useEffect(() => {
    LoginDetails();
  }, []);

  function Logout() {
    Cookies.remove("User");
    Cookies.remove("log_id");
    navigate("/");
  }
  function bothwork() {
    closeMobileMenu();
    Logout();
  }
  return (
    <div className="dashboard-container">
      <div className="topbar">
        <div className="topbar-logo">JOB MARKET</div>
      </div>

      <div className="dashboard-content">
        <div className="sidebar">
          <div className="sidebar-profile">
            {image ? (
              <img src={image} className="user-img" />
            ) : (
              <img src="user8.jpeg" alt="Profile" />
            )}
            <p>{username}</p>
            <span>✅ Verified</span>
          </div>
          <nav>
            <ul>
              <li className={`dropdown ${isprofileDropdown ? "open" : ""}`}>
                <NavLink
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleProfile();
                  }}
                  className="dropdown-toggles"
                >
                  <FontAwesomeIcon icon={faUser} className="icon" /> Profile
                  {isprofileDropdown ? (
                    <FaChevronUp className="dropdown-icons" />
                  ) : (
                    <FaChevronDown className="dropdown-icons" />
                  )}
                </NavLink>
                {isprofileDropdown && (
                  <ul className="dropdown-menuse">
                    <li>
                      <NavLink to="/profile">View</NavLink>
                    </li>
                    <li>
                      <NavLink to="/add_profile_details">Add</NavLink>
                    </li>
                  </ul>
                )}
              </li>
              <li className={`dropdown ${isDropdownOpen ? "open" : ""}`}>
                <NavLink
                  to="#"
                  className="dropdown-toggles"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleDropdown();
                  }}
                >
                  <FontAwesomeIcon icon={faFileAlt} className="icon" /> Jobs
                  {isDropdownOpen ? (
                    <FaChevronUp className="dropdown-icons" />
                  ) : (
                    <FaChevronDown className="dropdown-icons" />
                  )}
                </NavLink>
                {isDropdownOpen && (
                  <ul className="dropdown-menuse">
                    <li>
                      <NavLink to="/all_jobs_employee">All</NavLink>
                    </li>
                    <li>
                      <NavLink to="">View</NavLink>
                    </li>
                  </ul>
                )}
              </li>
              <li className={`dropdown ${isProductsdown ? "open" : ""}`}>
                <NavLink
                  to="#"
                  className="dropdown-toggles"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleProducts();
                  }}
                >
                  <FontAwesomeIcon icon={faArchive} className="icon" /> Products
                  {isProductsdown ? (
                    <FaChevronUp className="dropdown-icons" />
                  ) : (
                    <FaChevronDown className="dropdown-icons" />
                  )}
                </NavLink>
                {isProductsdown && (
                  <ul className="dropdown-menuse">
                    <li>
                      <NavLink to="/all_products_employee">All</NavLink>
                    </li>
                    <li>
                      <NavLink to="">Bought</NavLink>
                    </li>
                  </ul>
                )}
              </li>
              <li className={`dropdown ${isOptiondown ? "open" : ""}`}>
                <NavLink
                  to="#"
                  className="dropdown-toggles"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleOption();
                  }}
                >
                  <FontAwesomeIcon icon={faList} className="icon" /> Requests
                  {isOptiondown ? (
                    <FaChevronUp className="dropdown-icons" />
                  ) : (
                    <FaChevronDown className="dropdown-icons" />
                  )}
                </NavLink>
                {isOptiondown && (
                  <ul className="dropdown-menuse">
                    <li>
                      <NavLink to="/resignation_request_employee">
                        Resign
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="">Project</NavLink>
                    </li>
                    <li>
                      <NavLink to="/all_resignation_requests_employee">
                        All Resignation
                      </NavLink>
                    </li>
                  </ul>
                )}
              </li>
              <li>
                <NavLink to="/premiumMembershipEmployee">
                  <MdCardMembership className="icon" />
                  Premium Membership
                </NavLink>
              </li>
              <li>
                <NavLink to="/change-request">
                  <FontAwesomeIcon icon={faBriefcase} className="icon" />{" "}
                  Job/Stream Change
                </NavLink>
              </li>

              <li>
                <NavLink to="/add-certificate">
                  <FontAwesomeIcon icon={faFileCirclePlus} className="icon" />{" "}
                  Add Certificate
                </NavLink>
              </li>
              <li>
                <NavLink to="/technical_support_employee_page">
                  <FontAwesomeIcon icon={faGears} className="icon" />
                  Technical Support
                </NavLink>
              </li>
              <li>
                <NavLink to="/showwork">
                  <FontAwesomeIcon icon={faFileCirclePlus} className="icon" />{" "}
                  Work
                </NavLink>
              </li>
              <li>
                <NavLink to="/showrating">
                  <FontAwesomeIcon icon={faFileCirclePlus} className="icon" />{" "}
                  Rating
                </NavLink>
              </li>
              <li>
                <a onClick={Logout}>
                  <FontAwesomeIcon icon={faSignOutAlt} className="icon" />
                  Logout
                </a>
              </li>
            </ul>
          </nav>
        </div>

        <div className="mobile-header">
          <FaBars className="menu-icon" onClick={toggleMobileMenu} />
        </div>

        {isMobileMenuOpen && (
          <div className="sidebar mobile-sidebar">
            <button className="close-menu-btn" onClick={closeMobileMenu}>
              <FaTimes className="close-icon" />
            </button>
            <nav>
              <ul>
                <li>
                  <button className="dropdown-toggles" onClick={toggleProfile}>
                    <FontAwesomeIcon icon={faUser} className="icon" /> Profile
                    {isprofileDropdown ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </button>
                  {isprofileDropdown && (
                    <ul className="dropdown-menus">
                      <li>
                        <NavLink to="/profile" onClick={closeMobileMenu}>
                          View
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/add_profile_details"
                          onClick={closeMobileMenu}
                        >
                          Add
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li>
                <li>
                  <button className="dropdown-toggles" onClick={toggleDropdown}>
                    <FontAwesomeIcon icon={faFileAlt} className="icon" /> Jobs
                    {isDropdownOpen ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </button>
                  {isDropdownOpen && (
                    <ul className="dropdown-menus">
                      <li>
                        <NavLink
                          to="/all_jobs_employee"
                          onClick={closeMobileMenu}
                        >
                          All
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="" onClick={closeMobileMenu}>
                          View
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li>
                <li>
                  <button className="dropdown-toggles" onClick={toggleProducts}>
                    <FontAwesomeIcon icon={faArchive} className="icon" />{" "}
                    Products
                    {isProductsdown ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </button>
                  {isProductsdown && (
                    <ul className="dropdown-menus">
                      <li>
                        <NavLink
                          to="/all_products_employee"
                          onClick={closeMobileMenu}
                        >
                          All
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="" onClick={closeMobileMenu}>
                          Bought
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li>
                <li>
                  <button className="dropdown-toggles" onClick={toggleOption}>
                    <FontAwesomeIcon icon={faList} className="icon" /> Requests
                    {isOptiondown ? (
                      <FaChevronUp className="dropdown-icons" />
                    ) : (
                      <FaChevronDown className="dropdown-icons" />
                    )}
                  </button>
                  {isOptiondown && (
                    <ul className="dropdown-menus">
                      <li>
                        <NavLink
                          to="/resignation_request_employee"
                          onClick={closeMobileMenu}
                        >
                          Resign
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="" onClick={closeMobileMenu}>
                          Project
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/all_resignation_requests_employee"
                          onClick={closeMobileMenu}
                        >
                          All Resignation
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li>
                <li>
                  <NavLink
                    to="/premiumMembershipEmployee"
                    onClick={closeMobileMenu}
                  >
                    <MdCardMembership className="icon" />
                    Premium Membership
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/change-request">
                    <FontAwesomeIcon icon={faBriefcase} className="icon" />{" "}
                    Job/Stream Change
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/add-certificate">
                    <FontAwesomeIcon icon={faFileCirclePlus} className="icon" />{" "}
                    Add Certificate
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/technical_support_employee_page"
                    onClick={bothwork}
                  >
                    <FontAwesomeIcon icon={faGears} className="icon" />{" "}
                    Technical Support
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/login" onClick={bothwork}>
                    <FontAwesomeIcon icon={faSignOutAlt} className="icon" />{" "}
                    Logout
                  </NavLink>
                </li>
              </ul>
            </nav>
          </div>
        )}
      </div>
    </div>
  );
}
export default EmployeeNavbar;
